export default "__VITE_ASSET__DxmI$KEy__"